import { BusinessDetailsDraft } from '../components/business/modal'
import { GuestInvoiceDraftPayload } from './guestInvoiceDraftStorage'
import { hasSavedBusinessDetails, SavedUserProfile } from './guestHydrationOrchestrator'

const normalize = (value: unknown): string => String(value ?? '').trim()

export const guestDraftToBusinessDetailsDraft = (
  draft: GuestInvoiceDraftPayload,
  profile: SavedUserProfile,
  accountEmail?: string,
): BusinessDetailsDraft => {
  const business = draft.values.businessDetails
  const draftEmail = normalize(business.email)
  const resolvedEmail = draftEmail
    || (!hasSavedBusinessDetails(profile) && accountEmail ? normalize(accountEmail) : '')

  return {
    'businessDetails.name': business.name ?? '',
    'businessDetails.email': resolvedEmail,
    'businessDetails.billingAddress': business.billingAddress ?? '',
    'businessDetails.taxRegistrationNumber': business.taxRegistrationNumber ?? '',
    'businessDetails.currency.code': business.currency?.code ?? '',
    'businessDetails.enableTax': !!business.enableTax,
    'businessDetails.tax.name': business.tax?.name ?? '',
    'businessDetails.tax.percentage': business.tax?.percentage ?? '',
  }
}
